module.exports = __webpack_public_path__ + "img/p_l.36c425fa.png";